import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';

export default async ({ Vue }) => {
  Vue.use(CoolLightBox);
};
